import * as $ from 'jquery';
var WpbbsaCalculatorService = /** @class */ (function () {
    function WpbbsaCalculatorService() {
    }
    WpbbsaCalculatorService.getInstance = function () {
        if (!WpbbsaCalculatorService.instance) {
            WpbbsaCalculatorService.instance = new WpbbsaCalculatorService();
        }
        return WpbbsaCalculatorService.instance;
    };
    WpbbsaCalculatorService.prototype.initializeDatePickers = function () {
        $(document).ready(function () {
            if ($('input.js-date-picker')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    daysOfWeekDisabled: [0, 6],
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker', datePickerConfig);
            }
            if ($('input.js-date-picker-full')) {
                var datePickerConfig = {
                    todayHighlight: true,
                    format: 'yyyy/mm/dd',
                    enableOnReadonly: true,
                    autoclose: true,
                    endDate: new Date()
                };
                instantiateDate('.js-date-picker-full', datePickerConfig);
            }
            function instantiateDate(pSelector, pConfig) {
                $('input' + pSelector).datepicker(pConfig).on('changeDate', function (event) {
                    var _event;
                    if (typeof window.event === 'function') {
                        _event = new Event('change');
                        this.dispatchEvent(_event);
                    }
                    else {
                        _event = document.createEvent('HTMLEvents');
                        _event.initEvent('change', false, false);
                        this.dispatchEvent(_event);
                    }
                });
            }
        });
    };
    // -- FORMATTERS -- //
    WpbbsaCalculatorService.prototype.formatter = function (value) {
        return parseFloat(value).toFixed(0).replace(/(\d)(?=(\d{3})+$)/g, '$1 ');
    };
    WpbbsaCalculatorService.prototype.noalpha = function (input) {
        input.value = input.value.replace(/[^0-9]/g, '');
    };
    WpbbsaCalculatorService.prototype.round = function (expr, decplaces) {
        var decpoint, str;
        str = '' + Math.round(expr * Math.pow(10, decplaces));
        while (str.length <= decplaces) {
            str = '0' + str;
        }
        decpoint = str.length - decplaces;
        return parseFloat(str.substring(0, decpoint) + '.' + str.substring(decpoint, str.length));
    };
    WpbbsaCalculatorService.prototype.pmt = function (rate, per, nper, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (nper === void 0) { nper = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var pmt_value, x;
        if ((per === 0) || (nper === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            pmt_value = -(fv + pv) / nper;
        }
        else {
            x = Math.pow(1 + rate, nper);
            pmt_value = -((rate * (fv + x * pv)) / (-1 + x));
        }
        pmt_value = this.round(pmt_value, 2);
        return pmt_value;
    };
    WpbbsaCalculatorService.prototype.pmt_vaf = function (rate, period, value, futurevalue, type) {
        if (rate === void 0) { rate = 0; }
        if (period === void 0) { period = 0; }
        if (value === void 0) { value = 0; }
        if (futurevalue === void 0) { futurevalue = 0; }
        if (type === void 0) { type = 0; }
        if (!futurevalue) {
            futurevalue = 0;
        }
        if (!type) {
            type = 0;
        }
        if (rate === 0) {
            return -(value + futurevalue) / period;
        }
        var pvif = Math.pow(1 + rate, period);
        var pmt = rate / (pvif - 1) * -(value * pvif + futurevalue);
        if (type === 1) {
            pmt /= (1 + rate);
        }
        return pmt;
    };
    WpbbsaCalculatorService.prototype.nper = function (rate, per, pmt, pv, fv) {
        if (rate === void 0) { rate = 0; }
        if (per === void 0) { per = 0; }
        if (pmt === void 0) { pmt = 0; }
        if (pv === void 0) { pv = 0; }
        if (fv === void 0) { fv = 0; }
        var nper_value;
        if ((per === 0) || (pmt === 0)) {
            return 0;
        }
        rate = rate / (per * 100);
        if (rate === 0) {
            nper_value = -(fv + pv) / pmt;
        }
        else {
            nper_value = Math.log((-fv * rate + pmt) / (pmt + rate * pv)) / Math.log(1 + rate);
        }
        var end = this.round(nper_value, 2);
        return parseFloat(end);
    };
    WpbbsaCalculatorService.prototype.cumipmt = function (amount, rate, term, pmt) {
        if (amount === void 0) { amount = 0; }
        if (rate === void 0) { rate = 0; }
        if (term === void 0) { term = 0; }
        if (pmt === void 0) { pmt = 0; }
        var i, insertedAmount, interestSavings, k, ref, totalInterest, value1, value2, value3;
        totalInterest = 0;
        insertedAmount = amount;
        interestSavings = 0;
        for (i = k = 0, ref = term; 0 <= ref ? k < ref : k > ref; i = 0 <= ref ? ++k : --k) {
            value1 = insertedAmount * (rate / 1200);
            value2 = pmt - value1;
            value3 = insertedAmount - value2;
            insertedAmount = value3;
            interestSavings = interestSavings + value1;
        }
        return interestSavings;
    };
    WpbbsaCalculatorService.prototype.cumipmt2 = function (rate, periods, value, start, end, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (value === void 0) { value = 0; }
        if (start === void 0) { start = 0; }
        if (end === void 0) { end = 0; }
        if (type === void 0) { type = 0; }
        var i, interest, payment;
        payment = this.pmt_cumipmt(rate, periods, value, 0, type);
        interest = 0;
        if (start === 1) {
            if (type === 0) {
                interest = -value;
                start++;
            }
        }
        i = start;
        while (i <= end) {
            if (type === 1) {
                interest += this.fv(rate, i - 2, payment, value, 1) - payment;
            }
            else {
                interest += this.fv(rate, i - 1, payment, value, 0);
            }
            i++;
        }
        interest *= rate;
        return -interest;
    };
    WpbbsaCalculatorService.prototype.fv = function (rate, periods, payment, value, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (payment === void 0) { payment = 0; }
        if (value === void 0) { value = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        value = value || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = value + payment * periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = value * term + payment * (1 + rate) * (term - 1) / rate;
            }
            else {
                result = value * term + payment * (term - 1) / rate;
            }
        }
        return -result;
    };
    WpbbsaCalculatorService.prototype.pmt_cumipmt = function (rate, periods, present, future, type) {
        if (rate === void 0) { rate = 0; }
        if (periods === void 0) { periods = 0; }
        if (present === void 0) { present = 0; }
        if (future === void 0) { future = 0; }
        if (type === void 0) { type = 0; }
        var result, term;
        future = future || 0;
        type = type || 0;
        result = void 0;
        if (rate === 0) {
            result = (present + future) / periods;
        }
        else {
            term = Math.pow(1 + rate, periods);
            if (type === 1) {
                result = (future * rate / (term - 1) + present * rate / (1 - (1 / term))) / (1 + rate);
            }
            else {
                result = future * rate / (term - 1) + present * rate / (1 - (1 / term));
            }
        }
        return -result;
    };
    // -- SIMPLE INTEREST -- //
    WpbbsaCalculatorService.prototype.simpleInterest = function (deposit, term, interest) {
        if (deposit === void 0) { deposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var result = 0;
        var _interest = (interest / 100);
        var _years = (term / 12);
        result = deposit * (1 + (_interest * _years));
        return {
            amount: this.formatter(result)
        };
    };
    // -- COMPOUND INTEREST -- //
    WpbbsaCalculatorService.prototype.compoundInterest = function (deposit, monthlyDeposit, term, interest) {
        if (deposit === void 0) { deposit = 0; }
        if (monthlyDeposit === void 0) { monthlyDeposit = 0; }
        if (term === void 0) { term = 0; }
        if (interest === void 0) { interest = 10.25; }
        var _deposit = parseFloat(deposit);
        var _monthlyDeposit = parseFloat(monthlyDeposit);
        var _term = parseFloat(term);
        var _interest = parseFloat(interest);
        var _intRate = this.round((Math.pow(1 + _interest / 100, 1 / 12) - 1), 3);
        var result = 0;
        for (var a = 0; a < _term; a++) {
            var _int = 0;
            if (a === 0) {
                _int = (_deposit * _intRate);
                result = _deposit;
            }
            else {
                _int = ((result * _intRate) + _monthlyDeposit);
            }
            _int = this.round(_int, 2);
            result = this.round((result + _int), 2);
        }
        return {
            amount: this.formatter(result)
        };
    };
    return WpbbsaCalculatorService;
}());
export { WpbbsaCalculatorService };



//////////////////
// WEBPACK FOOTER
// ./services/wpbbsa-calculator.service.ts
// module id = 64
// module chunks = 0